;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/blog/:slug\",\"regex\":\"^/blog/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/card/:slug\",\"regex\":\"^/card/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/careers/:slug\",\"regex\":\"^/careers/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/cookie-policy\"},{\"path\":\"/eu-project\"},{\"path\":\"/privacy-policy\"},{\"path\":\"/about\"},{\"path\":\"/blog\"},{\"path\":\"/careers\"},{\"path\":\"/careers/open-application\"},{\"path\":\"/contact\"},{\"path\":\"/error\"},{\"path\":\"/work\"},{\"path\":\"/work/bird-species-identifying-app\"},{\"path\":\"/work/custom-apparel-fulfillment-solution\"},{\"path\":\"/work/enterprise-rag-ai-solutions\"},{\"path\":\"/work/football\"},{\"path\":\"/work/management-solution-for-construction\"},{\"path\":\"/work/pista-precision-racing-mobile-platform\"}],\"isrRoutes\":[\"/blog/:slug\",\"/card/:slug\",\"/careers/:slug\"]}";globalThis["_sentryNextJsVersion"] = "16.4.0";import * as Sentry from '@sentry/nextjs'

const sentryDsn = process.env.NEXT_PUBLIC_SENTRY_DSN
const sentryEnv = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || process.env.NODE_ENV
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: sentryEnv,
    tracesSampleRate: sentryEnv?.toLowerCase() === 'production' ? 0.1 : 1,
    debug: false,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    normalizeDepth: 6,
  })

  // Replay is large, so it's loaded from the Sentry CDN after the page has loaded instead of being bundled
  const loadReplay = () =>
    Sentry.lazyLoadIntegration('replayIntegration')
      .then((replayIntegration) => Sentry.addIntegration(replayIntegration({ maskAllText: true, blockAllMedia: true })))
      .catch(() => {})

  if (document.readyState === 'complete') {
    loadReplay()
  } else {
    window.addEventListener('load', loadReplay, { once: true })
  }
}

// This export will instrument router navigations, and is only relevant if you enable tracing.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
